import PropTypes from "prop-types";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import imagesMetaData from "@/../.sourceflow/image_metadata.json";

/**
 *
 * @param className
 * @param img
 * @param size
 * @param alt
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function Image({ className, img, resize, size, alt }) {
  if (!img) {
    return null;
  }

  if (typeof img === "string") {
    return <SourceFlowImage className={className} src={img} resize={resize} size={size} alt={alt} />;
  }

  if (typeof img === "object") {
    if ("path" in img) {
      return <SourceFlowImage className={className} path={img.path} resize={resize} size={size} imagesMetaData={imagesMetaData} />;
    }

    if ("src" in img && img.src) {
      return <SourceFlowImage className={className} src={img.src} alt={img.alt ?? "tbd"} resize={resize} size={size} />;
    }
  }

  return null;
}

Image.defaultProps = {
  className: "",
  img: null,
  resize: true,
  size: null,
  alt: null,
};

Image.propTypes = {
  className: PropTypes.string,
  img: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      path: PropTypes.string,
    }),
    PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    }),
  ]),
  size: PropTypes.string,
  alt: PropTypes.string,
};
